"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServLiveintent = void 0;
const base_1 = require("./base");
/**
 * Liveintent
 */
class AnServLiveintent extends base_1.AnServBase {
    static isLoaded() {
        return ((window.liQ !== undefined) &&
            (window.liQ.push !== undefined));
    }
    static sendEventViewContent(pixelId, contentType) {
        liQ.push({
            event: "viewContent",
            contentType: contentType,
        });
        this.logEvent({
            cmd: "push",
            event: "viewContent",
            contentType: contentType,
        });
        return true;
    }
    static sendEventAddToCartSubscription(pixelId) {
        const cmd = {
            event: "addToCart",
        };
        liQ.push(cmd);
        this.logEvent(Object.assign({ cmd: "push" }, cmd));
        return true;
    }
    static sendConversionEmailSignup(pixelId, email) {
        const cmd = {
            event: "conversion",
            name: "email_signup",
            email: email,
        };
        liQ.push(cmd);
        this.logEvent(Object.assign({ cmd: "push" }, cmd));
        return true;
    }
    static sendConversionProductPurchase(pixelId, userId, email) {
        const cmd = {
            event: "conversion",
            name: "product_purchase",
            conversionId: userId.toString(),
            email: email,
        };
        liQ.push(cmd);
        this.logEvent(Object.assign({ cmd: "push" }, cmd));
        return true;
    }
}
exports.AnServLiveintent = AnServLiveintent;
AnServLiveintent.serviceName = "Liveintent";
